import React from "react";
import { Controller } from "react-hook-form";
import { TextField, Stack, Box } from "@mui/material";

const TripTypeForm = ({ control, watch, tripType, errors }) => {
  const today = new Date().toISOString().split("T")[0];
  const departDate = watch("departDate", today);

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={2}
      sx={{ width: "100%" }}
    >
      <Box flex={1}>
        <Controller
          name="departDate"
          control={control}
          rules={{ required: "Depart date is required" }}
          render={({ field }) => (
            <TextField
              {...field}
              label="Departure date"
              type="date"
              fullWidth
              InputLabelProps={{ shrink: true }}
              error={!!errors.departDate}
              helperText={errors.departDate?.message}
              inputProps={{ min: today }}
            />
          )}
        />
      </Box>

      {tripType === "return" && (
        <Box flex={1}>
          <Controller
            name="returnDate"
            control={control}
            rules={{
              required: "Return date is required",
              validate: (value) =>
                value >= departDate ||
                "Return date cannot be before the depart date",
            }}
            render={({ field }) => (
              <TextField
                {...field}
                label="Return Date"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                error={!!errors.returnDate}
                helperText={errors.returnDate?.message}
                inputProps={{ min: departDate }}
              />
            )}
          />
        </Box>
      )}
    </Stack>
  );
};

export default TripTypeForm;
